import React from 'react';
import styles from './styles.module.css';

const List = ({ text }) => {
  return (
    <>
      {text.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </>
  );
};

const Includes = ({ includes }) => (
  <>
    <div className={styles.root}>
      <div className={styles.flex}>
        <img
          alt={'иконка раздела «Что включает курс:»'}
          className={styles.icon}
          src="https://images.ctfassets.net/67gkhzpoimdx/53md8AWcGIqXLV5L9RQG2b/e6a20c1a71049389a660de79325b611b/includes.svg"
        />
        <span className={styles.title}>Что я получаю</span>
      </div>
      <ul className={styles.list}>
        {includes.map((item, i) => (
          <List key={i} text={item.text} />
        ))}
      </ul>
    </div>
  </>
);

export default Includes;
